
import { Component, OnInit, OnDestroy } from '@angular/core';

import { HealthService } from '../../../services/health.service';
import { Subscription } from 'rxjs';




@Component({
  selector: 'app-list-health',
  templateUrl: './list-health.component.html',
  styleUrls: ['./list-health.component.css']
})


export class ListHealthComponent implements OnInit, OnDestroy {
  healthStatusValue: any[] = [];
  resultset: any;

  criticalCount = 0;
  warningCount = 0;
  normalCount = 0;
  unknownCount = 0;

  constructor(private healthService: HealthService) {
    this.healthData = this.healthService.getHealthComponentData();
  }
  subscriptions: Subscription[] = [];
  healthData: any;
  states: any;

  ngOnInit() {
    setInterval(() => {
      this.healthData = this.healthService.getHealthComponentData();

    }, 2000 * 60);

  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscriptions.forEach(s => s.unsubscribe());
  }



  trackBySourceName(index, contact) {
    return contact.id;
  }
  getHealthStatus(data) {


    this.subscriptions.push(
      this.healthService.getHealthStatus()
        .subscribe(result => {
          const componentArray = [];
          result.forEach(component => {
            component.cluster.forEach(cluster => {
              const clusterArray = [];
              if (typeof Object.keys(cluster) !== 'undefined' && Object.keys(cluster).length > 0) {
                Object.keys(cluster).forEach(ip => {
                  clusterArray.push({ 'ip': ip, 'status': cluster[ip].status });
                });
              }
              componentArray.push({ 'compId': component.compId, 'sourceId': component.sourceId, 'cluster': clusterArray });
            });
          });

          componentArray.forEach(comp => {
            const dataComponent = data.find(component =>
              component.sourceId === comp.sourceId && component.compId === comp.compId
            );
            dataComponent.clusterStatus = comp.cluster;
          });
          this.healthData = this.healthService.getHealthComponentData();
          this.healthService.getHealthStatusCount(this.healthData);
        }));

  }

  groupDatabySourceName(data) {

    const groups = new Set(data.map(comp => comp.sourceId));
    const healthDataCompArray = [];
    groups.forEach(function (group) {
      healthDataCompArray.push({
        name: group,
        values: data.filter(i => i.sourceId === group)
      });
    });
    this.healthData = healthDataCompArray;

  }
  getHealthStatusCount(data) {

    this.criticalCount = 0;
    this.warningCount = 0;
    this.normalCount = 0;
    this.unknownCount = 0;

    data.forEach(component => {

      if (component.clusterStatus) {
        const isCritical = component.clusterStatus.find(comp => comp.status === 'CRITICAL');
        if (isCritical) {
          this.criticalCount = this.criticalCount + 1;
          return;
        } else {
          const isWarning = component.clusterStatus.find(comp => comp.status === 'WARNING');
          if (isWarning) {
            this.warningCount = this.warningCount + 1;
            return;
          } else {
            const isUnknown = component.clusterStatus.find(comp => comp.status === 'UNKNOWN');
            if (isUnknown) {
              this.unknownCount = this.unknownCount + 1;
              return;
            } else {
              const isNormal = component.clusterStatus.find(comp => comp.status === 'NORMAL');
              if (isNormal) {
                this.normalCount = this.normalCount + 1;
                return;
              }
            }
          }
        }
      }

    });
    this.healthService.healthArray.forEach(health => {
      if (health.name === 'CRITICAL') {
        health.value = this.criticalCount.toString();
        return;
      }
      if (health.name === 'WARNING') {
        health.value = this.warningCount.toString();
        return;
      }
      if (health.name === 'UNKNOWN') {
        health.value = this.unknownCount.toString();
        return;
      }
      if (health.name === 'NORMAL') {
        health.value = this.normalCount.toString();
        return;
      }

    });

  }

}
